module.exports = __webpack_public_path__ + "img/gs-pic.a6a36696.png";